import { render, staticRenderFns } from "./productionCapacitySummaryWidget.vue?vue&type=template&id=51408529&scoped=true&"
import script from "./productionCapacitySummaryWidget.vue?vue&type=script&lang=js&"
export * from "./productionCapacitySummaryWidget.vue?vue&type=script&lang=js&"
import style0 from "./productionCapacitySummaryWidget.vue?vue&type=style&index=0&id=51408529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51408529",
  null
  
)

export default component.exports